import React, { useEffect } from 'react'
import {
  Box,
  Alert,
  Heading,
  Text,
  TertiaryButton,
} from '@moonpig/launchpad-components'
import { useAuthenticationLocaleText } from '../../text-localisation'
import {
  trackAccountRecoveryClick,
  trackSocialLoginOptionsLoadErrorImpression,
} from './tracking'

export const SocialLoginButtonsLoadError: React.FC<{
  handleAccountRecovery?: () => void
}> = ({ handleAccountRecovery }) => {
  const localiseText = useAuthenticationLocaleText()

  useEffect(() => {
    trackSocialLoginOptionsLoadErrorImpression()
  }, [])

  const handleAccountRecoveryClick = () => {
    if (handleAccountRecovery) {
      trackAccountRecoveryClick('social login unavailable')
      handleAccountRecovery()
    }
  }

  return (
    <Alert variant="warning">
      <Heading
        level="h4"
        typography={{
          xs: 'typeMobileDisplay05',
          md: 'typeDesktopDisplay06',
        }}
        mb={4}
        ml={2}
      >
        {localiseText('auth_wizard.sociallogin_unavailable_title')}
      </Heading>
      <Box ml={2}>
        <Text>
          {localiseText('auth_wizard.sociallogin_unavailable_message')}
        </Text>
      </Box>
      {handleAccountRecovery && (
        <Box ml={2} display="">
          <TertiaryButton mb={6} mt={2} onClick={handleAccountRecoveryClick}>
            {localiseText('auth_wizard.account_recovery')}
          </TertiaryButton>
        </Box>
      )}
    </Alert>
  )
}
